<ng-template #settingsTemplate>
</ng-template>
<ng-template #contentTemplate>
    <svg class="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 188.1 46.044" style="enable-background:new 0 0 188.1 46.044;" xml:space="preserve">
<style type="text/css">
.stAbacus0{fill:#888996;}
.stAbacus1{fill:#C49C7F;}
.stAbacus2{fill:#A9714A;}
.stAbacus3{fill:url(#SVGID_1_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus4{fill:url(#SVGID_2_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus5{fill:url(#SVGID_3_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus6{fill:url(#SVGID_4_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus7{fill:url(#SVGID_5_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus8{fill:url(#SVGID_6_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus9{fill:url(#SVGID_7_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus10{fill:url(#SVGID_8_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus11{fill:url(#SVGID_9_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus12{fill:url(#SVGID_10_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus13{fill:url(#SVGID_11_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus14{fill:url(#SVGID_12_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus15{fill:#E5232B;}
.stAbacus16{opacity:0.3;}
.stAbacus17{fill:#FFFFFF;}
.stAbacus18{fill:url(#SVGID_13_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus19{fill:url(#SVGID_14_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus20{fill:url(#SVGID_15_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus21{fill:url(#SVGID_16_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus22{fill:url(#SVGID_17_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus23{fill:url(#SVGID_18_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus24{fill:url(#SVGID_19_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus25{fill:url(#SVGID_20_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus26{fill:url(#SVGID_21_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus27{fill:url(#SVGID_22_);stroke:#0090C9;stroke-width:0.15;}
.stAbacus28{fill:#DADADA;}
.stAbacus29{opacity:0.6;}
.stAbacus30{fill:#E52427;}
</style>
        <g id="Telraam">
	<g>
		<rect x="5.898" y="10.653" style="fill:#888996;" width="175.748" height="1.417"/>
        <rect x="5.898" y="10.653" style="fill:#888996;" width="175.748" height="1.417"/>
	</g>
            <g>
		<rect x="6.154" y="26.039" style="fill:#888996;" width="175.747" height="1.418"/>
                <rect x="6.154" y="26.039" style="fill:#888996;" width="175.747" height="1.418"/>
	</g>
            <rect x="0.351" y="0.235" style="fill:#C49C7F;" width="5.547" height="45.354"/>
            <rect x="3.98" y="0.235" style="fill:#A9714A;" width="2.556" height="45.354"/>
            <rect x="181.319" y="0.235" style="fill:#C49C7F;" width="5.669" height="45.354"/>
            <rect x="185.01" y="0.235" style="fill:#A9714A;" width="2.556" height="45.354"/>
</g>
        <g id="Kralen">
	<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="48.4072" y1="11.7566" x2="48.4072" y2="11.7566">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
        <stop  offset="0.0303" style="stop-color:#E7F4FA"/>
        <stop  offset="0.097" style="stop-color:#B7E0F0"/>
        <stop  offset="0.1692" style="stop-color:#8BCDE6"/>
        <stop  offset="0.2454" style="stop-color:#66BCDF"/>
        <stop  offset="0.3266" style="stop-color:#46AED8"/>
        <stop  offset="0.4144" style="stop-color:#2CA3D2"/>
        <stop  offset="0.5113" style="stop-color:#199BCE"/>
        <stop  offset="0.6222" style="stop-color:#0B95CB"/>
        <stop  offset="0.7591" style="stop-color:#0291CA"/>
        <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_1_);stroke:#0090C9;stroke-width:0.15;" d="M48.407,11.757"/>
            <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="56.9281" y1="9.0712" x2="56.9281" y2="9.0712">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.1035" style="stop-color:#EDF7FB"/>
                <stop  offset="0.312" style="stop-color:#BDE2F1"/>
                <stop  offset="0.6067" style="stop-color:#70C1E1"/>
                <stop  offset="0.9732" style="stop-color:#0893CB"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_2_);stroke:#0090C9;stroke-width:0.15;" d="M56.928,9.071"/>
            <linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="55.2638" y1="26.8925" x2="55.2638" y2="26.8925">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.0303" style="stop-color:#E7F4FA"/>
                <stop  offset="0.097" style="stop-color:#B7E0F0"/>
                <stop  offset="0.1692" style="stop-color:#8BCDE6"/>
                <stop  offset="0.2454" style="stop-color:#66BCDF"/>
                <stop  offset="0.3266" style="stop-color:#46AED8"/>
                <stop  offset="0.4144" style="stop-color:#2CA3D2"/>
                <stop  offset="0.5113" style="stop-color:#199BCE"/>
                <stop  offset="0.6222" style="stop-color:#0B95CB"/>
                <stop  offset="0.7591" style="stop-color:#0291CA"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_3_);stroke:#0090C9;stroke-width:0.15;" d="M55.264,26.893"/>
            <linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="56.9321" y1="24.5295" x2="56.9321" y2="24.5295">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.1035" style="stop-color:#EDF7FB"/>
                <stop  offset="0.312" style="stop-color:#BDE2F1"/>
                <stop  offset="0.6067" style="stop-color:#70C1E1"/>
                <stop  offset="0.9732" style="stop-color:#0893CB"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_4_);stroke:#0090C9;stroke-width:0.15;" d="M56.932,24.53"/>
            <g>
		<linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="15.8268" y1="11.3607" x2="15.8268" y2="11.3607">
			<stop  offset="0" style="stop-color:#FFFFFF"/>
            <stop  offset="0.0303" style="stop-color:#E7F4FA"/>
            <stop  offset="0.097" style="stop-color:#B7E0F0"/>
            <stop  offset="0.1692" style="stop-color:#8BCDE6"/>
            <stop  offset="0.2454" style="stop-color:#66BCDF"/>
            <stop  offset="0.3266" style="stop-color:#46AED8"/>
            <stop  offset="0.4144" style="stop-color:#2CA3D2"/>
            <stop  offset="0.5113" style="stop-color:#199BCE"/>
            <stop  offset="0.6222" style="stop-color:#0B95CB"/>
            <stop  offset="0.7591" style="stop-color:#0291CA"/>
            <stop  offset="1" style="stop-color:#0090C9"/>
		</linearGradient>
                <path style="fill:url(#SVGID_5_);stroke:#0090C9;stroke-width:0.15;" d="M15.827,11.361"/>
                <linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="17.4908" y1="9.0038" x2="17.4908" y2="9.0038">
			<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1035" style="stop-color:#EDF7FB"/>
                    <stop  offset="0.312" style="stop-color:#BDE2F1"/>
                    <stop  offset="0.6067" style="stop-color:#70C1E1"/>
                    <stop  offset="0.9732" style="stop-color:#0893CB"/>
                    <stop  offset="1" style="stop-color:#0090C9"/>
		</linearGradient>
                <path style="fill:url(#SVGID_6_);stroke:#0090C9;stroke-width:0.15;" d="M17.491,9.004"/>
	</g>
            <linearGradient id="SVGID_7_" gradientUnits="userSpaceOnUse" x1="25.7616" y1="11.3607" x2="25.7616" y2="11.3607">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.0303" style="stop-color:#E7F4FA"/>
                <stop  offset="0.097" style="stop-color:#B7E0F0"/>
                <stop  offset="0.1692" style="stop-color:#8BCDE6"/>
                <stop  offset="0.2454" style="stop-color:#66BCDF"/>
                <stop  offset="0.3266" style="stop-color:#46AED8"/>
                <stop  offset="0.4144" style="stop-color:#2CA3D2"/>
                <stop  offset="0.5113" style="stop-color:#199BCE"/>
                <stop  offset="0.6222" style="stop-color:#0B95CB"/>
                <stop  offset="0.7591" style="stop-color:#0291CA"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_7_);stroke:#0090C9;stroke-width:0.15;" d="M25.762,11.361"/>
            <linearGradient id="SVGID_8_" gradientUnits="userSpaceOnUse" x1="27.4256" y1="9.0038" x2="27.4256" y2="9.0038">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.1035" style="stop-color:#EDF7FB"/>
                <stop  offset="0.312" style="stop-color:#BDE2F1"/>
                <stop  offset="0.6067" style="stop-color:#70C1E1"/>
                <stop  offset="0.9732" style="stop-color:#0893CB"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_8_);stroke:#0090C9;stroke-width:0.15;" d="M27.426,9.004"/>
            <linearGradient id="SVGID_9_" gradientUnits="userSpaceOnUse" x1="35.7087" y1="11.3607" x2="35.7087" y2="11.3607">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.0303" style="stop-color:#E7F4FA"/>
                <stop  offset="0.097" style="stop-color:#B7E0F0"/>
                <stop  offset="0.1692" style="stop-color:#8BCDE6"/>
                <stop  offset="0.2454" style="stop-color:#66BCDF"/>
                <stop  offset="0.3266" style="stop-color:#46AED8"/>
                <stop  offset="0.4144" style="stop-color:#2CA3D2"/>
                <stop  offset="0.5113" style="stop-color:#199BCE"/>
                <stop  offset="0.6222" style="stop-color:#0B95CB"/>
                <stop  offset="0.7591" style="stop-color:#0291CA"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_9_);stroke:#0090C9;stroke-width:0.15;" d="M35.709,11.361"/>
            <linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="37.3727" y1="9.0038" x2="37.3727" y2="9.0038">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.1035" style="stop-color:#EDF7FB"/>
                <stop  offset="0.312" style="stop-color:#BDE2F1"/>
                <stop  offset="0.6067" style="stop-color:#70C1E1"/>
                <stop  offset="0.9732" style="stop-color:#0893CB"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_10_);stroke:#0090C9;stroke-width:0.15;" d="M37.373,9.004"/>
            <linearGradient id="SVGID_11_" gradientUnits="userSpaceOnUse" x1="45.6558" y1="11.3607" x2="45.6558" y2="11.3607">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.0303" style="stop-color:#E7F4FA"/>
                <stop  offset="0.097" style="stop-color:#B7E0F0"/>
                <stop  offset="0.1692" style="stop-color:#8BCDE6"/>
                <stop  offset="0.2454" style="stop-color:#66BCDF"/>
                <stop  offset="0.3266" style="stop-color:#46AED8"/>
                <stop  offset="0.4144" style="stop-color:#2CA3D2"/>
                <stop  offset="0.5113" style="stop-color:#199BCE"/>
                <stop  offset="0.6222" style="stop-color:#0B95CB"/>
                <stop  offset="0.7591" style="stop-color:#0291CA"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_11_);stroke:#0090C9;stroke-width:0.15;" d="M45.656,11.361"/>
            <linearGradient id="SVGID_12_" gradientUnits="userSpaceOnUse" x1="47.3198" y1="9.0038" x2="47.3198" y2="9.0038">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.1035" style="stop-color:#EDF7FB"/>
                <stop  offset="0.312" style="stop-color:#BDE2F1"/>
                <stop  offset="0.6067" style="stop-color:#70C1E1"/>
                <stop  offset="0.9732" style="stop-color:#0893CB"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_12_);stroke:#0090C9;stroke-width:0.15;" d="M47.32,9.004"/>
            <g class="bead" id="{{beadsList[0].id}}" (click)="moveBeads($event)">
		<g>
			<g>
				<path style="fill:#E5232B;" d="M92.8,11.4c0,2.7-2.2,4.9-4.9,4.9c-2.7,0-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9C90.6,6.5,92.8,8.7,92.8,11.4z"/>
			</g>
		</g>
                <g style="opacity:0.3;">
			<g>
				<path style="fill:#FFFFFF;" d="M85,8.9c-0.3,0.5-0.5,1.2-0.2,1.7c0.2,0.4,0.5,0.2,0.7,0c0.6-0.6,1.2-1.2,1.9-1.6c0.3-0.2,1.8-0.8,1.4-1.3c-0.4-0.5-1.3-0.4-1.8-0.3C86.1,7.6,85.4,8.2,85,8.9z"/>
			</g>
		</g>
	</g>
            <g class="bead" id="{{beadsList[1].id}}" (click)="moveBeads($event)">
		<path style="fill:#E5232B;" d="M92.9,11.4c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9s-2.2,4.9-4.9,4.9C95.1,16.3,92.9,14.1,92.9,11.4"/>
                <g style="opacity:0.3;">
			<g>
				<path style="fill:#FFFFFF;" d="M94.9,9c-0.3,0.5-0.5,1.2-0.2,1.7c0.2,0.4,0.5,0.2,0.7,0c0.6-0.6,1.2-1.2,1.9-1.6c0.3-0.2,1.8-0.8,1.4-1.3c-0.4-0.5-1.3-0.4-1.8-0.3C96.1,7.7,95.3,8.3,94.9,9z"/>
			</g>
		</g>
	</g>
            <g class="bead" id="{{beadsList[2].id}}" (click)="moveBeads($event)">
		<path style="fill:#E5232B;" d="M102.8,11.4c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9s-2.2,4.9-4.9,4.9C105,16.3,102.8,14.1,102.8,11.4"/>
                <g style="opacity:0.3;">
			<g>
				<path style="fill:#FFFFFF;" d="M104.9,9.2c-0.3,0.5-0.5,1.2-0.2,1.7c0.2,0.4,0.5,0.2,0.7,0c0.6-0.6,1.2-1.2,1.9-1.6c0.3-0.2,1.8-0.8,1.4-1.3c-0.4-0.5-1.3-0.4-1.8-0.3C106.1,7.9,105.3,8.5,104.9,9.2z"/>
			</g>
		</g>
	</g>
            <g class="bead" id="{{beadsList[3].id}}" (click)="moveBeads($event)">
		<path style="fill:#E5232B;" d="M112.6,11.4c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9s-2.2,4.9-4.9,4.9S112.6,14.1,112.6,11.4"/>
                <g style="opacity:0.3;">
			<g>
				<path style="fill:#FFFFFF;" d="M114.7,9.2c-0.3,0.5-0.5,1.2-0.2,1.7c0.2,0.4,0.5,0.2,0.7,0c0.6-0.6,1.2-1.2,1.9-1.6c0.3-0.2,1.8-0.8,1.4-1.3c-0.4-0.5-1.3-0.4-1.8-0.3C115.9,7.9,115.1,8.5,114.7,9.2z"/>
			</g>
		</g>
	</g>
            <g class="bead" id="{{beadsList[4].id}}" (click)="moveBeads($event)">
		<path style="fill:#E5232B;" d="M122.5,11.4c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9s-2.2,4.9-4.9,4.9S122.5,14.1,122.5,11.4"/>
                <g style="opacity:0.3;">
			<g>
				<path style="fill:#FFFFFF;" d="M124.5,9.2c-0.3,0.5-0.5,1.2-0.2,1.7c0.2,0.4,0.5,0.2,0.7,0c0.6-0.6,1.2-1.2,1.9-1.6c0.3-0.2,1.8-0.8,1.4-1.3c-0.4-0.5-1.3-0.4-1.8-0.3C125.6,7.9,124.9,8.5,124.5,9.2z"/>
			</g>
		</g>
	</g>
            <linearGradient id="SVGID_13_" gradientUnits="userSpaceOnUse" x1="48.3609" y1="27.0356" x2="48.3609" y2="27.0356">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.0303" style="stop-color:#E7F4FA"/>
                <stop  offset="0.097" style="stop-color:#B7E0F0"/>
                <stop  offset="0.1692" style="stop-color:#8BCDE6"/>
                <stop  offset="0.2454" style="stop-color:#66BCDF"/>
                <stop  offset="0.3266" style="stop-color:#46AED8"/>
                <stop  offset="0.4144" style="stop-color:#2CA3D2"/>
                <stop  offset="0.5113" style="stop-color:#199BCE"/>
                <stop  offset="0.6222" style="stop-color:#0B95CB"/>
                <stop  offset="0.7591" style="stop-color:#0291CA"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_13_);stroke:#0090C9;stroke-width:0.15;" d="M48.361,27.036"/>
            <linearGradient id="SVGID_14_" gradientUnits="userSpaceOnUse" x1="97.7561" y1="11.4077" x2="97.7561" y2="11.4077">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.0303" style="stop-color:#E7F4FA"/>
                <stop  offset="0.097" style="stop-color:#B7E0F0"/>
                <stop  offset="0.1692" style="stop-color:#8BCDE6"/>
                <stop  offset="0.2454" style="stop-color:#66BCDF"/>
                <stop  offset="0.3266" style="stop-color:#46AED8"/>
                <stop  offset="0.4144" style="stop-color:#2CA3D2"/>
                <stop  offset="0.5113" style="stop-color:#199BCE"/>
                <stop  offset="0.6222" style="stop-color:#0B95CB"/>
                <stop  offset="0.7591" style="stop-color:#0291CA"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_14_);stroke:#0090C9;stroke-width:0.15;" d="M97.756,11.408"/>
            <g>
		<linearGradient id="SVGID_15_" gradientUnits="userSpaceOnUse" x1="65.1757" y1="11.3607" x2="65.1757" y2="11.3607">
			<stop  offset="0" style="stop-color:#FFFFFF"/>
            <stop  offset="0.0303" style="stop-color:#E7F4FA"/>
            <stop  offset="0.097" style="stop-color:#B7E0F0"/>
            <stop  offset="0.1692" style="stop-color:#8BCDE6"/>
            <stop  offset="0.2454" style="stop-color:#66BCDF"/>
            <stop  offset="0.3266" style="stop-color:#46AED8"/>
            <stop  offset="0.4144" style="stop-color:#2CA3D2"/>
            <stop  offset="0.5113" style="stop-color:#199BCE"/>
            <stop  offset="0.6222" style="stop-color:#0B95CB"/>
            <stop  offset="0.7591" style="stop-color:#0291CA"/>
            <stop  offset="1" style="stop-color:#0090C9"/>
		</linearGradient>
                <path style="fill:url(#SVGID_15_);stroke:#0090C9;stroke-width:0.15;" d="M65.176,11.361"/>
                <linearGradient id="SVGID_16_" gradientUnits="userSpaceOnUse" x1="66.8397" y1="9.0038" x2="66.8397" y2="9.0038">
			<stop  offset="0" style="stop-color:#FFFFFF"/>
                    <stop  offset="0.1035" style="stop-color:#EDF7FB"/>
                    <stop  offset="0.312" style="stop-color:#BDE2F1"/>
                    <stop  offset="0.6067" style="stop-color:#70C1E1"/>
                    <stop  offset="0.9732" style="stop-color:#0893CB"/>
                    <stop  offset="1" style="stop-color:#0090C9"/>
		</linearGradient>
                <path style="fill:url(#SVGID_16_);stroke:#0090C9;stroke-width:0.15;" d="M66.84,9.004"/>
	</g>
            <linearGradient id="SVGID_17_" gradientUnits="userSpaceOnUse" x1="75.1106" y1="11.3607" x2="75.1106" y2="11.3607">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.0303" style="stop-color:#E7F4FA"/>
                <stop  offset="0.097" style="stop-color:#B7E0F0"/>
                <stop  offset="0.1692" style="stop-color:#8BCDE6"/>
                <stop  offset="0.2454" style="stop-color:#66BCDF"/>
                <stop  offset="0.3266" style="stop-color:#46AED8"/>
                <stop  offset="0.4144" style="stop-color:#2CA3D2"/>
                <stop  offset="0.5113" style="stop-color:#199BCE"/>
                <stop  offset="0.6222" style="stop-color:#0B95CB"/>
                <stop  offset="0.7591" style="stop-color:#0291CA"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_17_);stroke:#0090C9;stroke-width:0.15;" d="M75.111,11.361"/>
            <linearGradient id="SVGID_18_" gradientUnits="userSpaceOnUse" x1="76.7746" y1="9.0038" x2="76.7746" y2="9.0038">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.1035" style="stop-color:#EDF7FB"/>
                <stop  offset="0.312" style="stop-color:#BDE2F1"/>
                <stop  offset="0.6067" style="stop-color:#70C1E1"/>
                <stop  offset="0.9732" style="stop-color:#0893CB"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_18_);stroke:#0090C9;stroke-width:0.15;" d="M76.775,9.004"/>
            <linearGradient id="SVGID_19_" gradientUnits="userSpaceOnUse" x1="85.0577" y1="11.3607" x2="85.0577" y2="11.3607">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.0303" style="stop-color:#E7F4FA"/>
                <stop  offset="0.097" style="stop-color:#B7E0F0"/>
                <stop  offset="0.1692" style="stop-color:#8BCDE6"/>
                <stop  offset="0.2454" style="stop-color:#66BCDF"/>
                <stop  offset="0.3266" style="stop-color:#46AED8"/>
                <stop  offset="0.4144" style="stop-color:#2CA3D2"/>
                <stop  offset="0.5113" style="stop-color:#199BCE"/>
                <stop  offset="0.6222" style="stop-color:#0B95CB"/>
                <stop  offset="0.7591" style="stop-color:#0291CA"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_19_);stroke:#0090C9;stroke-width:0.15;" d="M85.058,11.361"/>
            <linearGradient id="SVGID_20_" gradientUnits="userSpaceOnUse" x1="86.7217" y1="9.0038" x2="86.7217" y2="9.0038">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.1035" style="stop-color:#EDF7FB"/>
                <stop  offset="0.312" style="stop-color:#BDE2F1"/>
                <stop  offset="0.6067" style="stop-color:#70C1E1"/>
                <stop  offset="0.9732" style="stop-color:#0893CB"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_20_);stroke:#0090C9;stroke-width:0.15;" d="M86.722,9.004"/>
            <linearGradient id="SVGID_21_" gradientUnits="userSpaceOnUse" x1="95.0048" y1="11.3607" x2="95.0048" y2="11.3607">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.0303" style="stop-color:#E7F4FA"/>
                <stop  offset="0.097" style="stop-color:#B7E0F0"/>
                <stop  offset="0.1692" style="stop-color:#8BCDE6"/>
                <stop  offset="0.2454" style="stop-color:#66BCDF"/>
                <stop  offset="0.3266" style="stop-color:#46AED8"/>
                <stop  offset="0.4144" style="stop-color:#2CA3D2"/>
                <stop  offset="0.5113" style="stop-color:#199BCE"/>
                <stop  offset="0.6222" style="stop-color:#0B95CB"/>
                <stop  offset="0.7591" style="stop-color:#0291CA"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_21_);stroke:#0090C9;stroke-width:0.15;" d="M95.005,11.361"/>
            <linearGradient id="SVGID_22_" gradientUnits="userSpaceOnUse" x1="96.6688" y1="9.0038" x2="96.6688" y2="9.0038">
		<stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.1035" style="stop-color:#EDF7FB"/>
                <stop  offset="0.312" style="stop-color:#BDE2F1"/>
                <stop  offset="0.6067" style="stop-color:#70C1E1"/>
                <stop  offset="0.9732" style="stop-color:#0893CB"/>
                <stop  offset="1" style="stop-color:#0090C9"/>
	</linearGradient>
            <path style="fill:url(#SVGID_22_);stroke:#0090C9;stroke-width:0.15;" d="M96.669,9.004"/>
            <g>
		<g class="bead" id="{{beadsList[5].id}}" (click)="moveBeads($event)">
			<g>
				<path class="stAbacus28" d="M142.2,11.4c0,2.7-2.2,4.9-4.9,4.9s-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9C140,6.5,142.2,8.7,142.2,11.4z"/>
			</g>
            <g class="stAbacus29">
				<g>
					<path class="stAbacus17" d="M134.3,8.9c-0.3,0.5-0.5,1.2-0.2,1.7c0.2,0.4,0.5,0.2,0.7,0c0.6-0.6,1.2-1.2,1.9-1.6c0.3-0.2,1.8-0.8,1.4-1.3c-0.4-0.5-1.3-0.4-1.8-0.3C135.5,7.6,134.7,8.2,134.3,8.9z"/>
				</g>
			</g>
		</g>
                <g class="bead" id="{{beadsList[6].id}}" (click)="moveBeads($event)">
			<path class="stAbacus28" d="M142.3,11.4c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9s-2.2,4.9-4.9,4.9S142.3,14.1,142.3,11.4"/>
                    <g class="stAbacus29">
				<g>
					<path class="stAbacus17" d="M144.3,9c-0.3,0.5-0.5,1.2-0.2,1.7c0.2,0.4,0.5,0.2,0.7,0c0.6-0.6,1.2-1.2,1.9-1.6c0.3-0.2,1.8-0.8,1.4-1.3c-0.4-0.5-1.3-0.4-1.8-0.3C145.4,7.7,144.7,8.3,144.3,9z"/>
				</g>
			</g>
		</g>
                <g class="bead" id="{{beadsList[7].id}}" (click)="moveBeads($event)">
			<path class="stAbacus28" d="M152.1,11.4c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9s-2.2,4.9-4.9,4.9C154.3,16.3,152.1,14.1,152.1,11.4"/>
                    <g class="stAbacus29">
				<g>
					<path class="stAbacus17" d="M154.3,9.2c-0.3,0.5-0.5,1.2-0.2,1.7c0.2,0.4,0.5,0.2,0.7,0c0.6-0.6,1.2-1.2,1.9-1.6c0.3-0.2,1.8-0.8,1.4-1.3c-0.4-0.5-1.3-0.4-1.8-0.3C155.4,7.9,154.7,8.5,154.3,9.2z"/>
				</g>
			</g>
		</g>
                <g class="bead" id="{{beadsList[8].id}}" (click)="moveBeads($event)">
			<path class="stAbacus28" d="M162,11.4c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9s-2.2,4.9-4.9,4.9C164.2,16.3,162,14.1,162,11.4"/>
                    <g class="stAbacus29">
				<g>
					<path class="stAbacus17" d="M164,9.2c-0.3,0.5-0.5,1.2-0.2,1.7c0.2,0.4,0.5,0.2,0.7,0c0.6-0.6,1.2-1.2,1.9-1.6c0.3-0.2,1.8-0.8,1.4-1.3c-0.4-0.5-1.3-0.4-1.8-0.3C165.2,7.9,164.4,8.5,164,9.2z"/>
				</g>
			</g>
		</g>
                <g class="bead" id="{{beadsList[9].id}}" (click)="moveBeads($event)">
			<path class="stAbacus28" d="M171.8,11.4c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9s-2.2,4.9-4.9,4.9S171.8,14.1,171.8,11.4"/>
                    <g class="stAbacus29">
				<g>
					<path class="stAbacus17" d="M173.8,9.2c-0.3,0.5-0.5,1.2-0.2,1.7c0.2,0.4,0.5,0.2,0.7,0c0.6-0.6,1.2-1.2,1.9-1.6c0.3-0.2,1.8-0.8,1.4-1.3c-0.4-0.5-1.3-0.4-1.8-0.3C175,7.9,174.2,8.5,173.8,9.2z"/>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g class="bead" id="{{beadsList[10].id}}" (click)="moveBeads($event)">
			<g>
				<g>
					<path style="fill:#E52427;" d="M92.86,26.747c0,2.698-2.19,4.89-4.889,4.89c-2.699,0-4.889-2.192-4.889-4.89
						s2.19-4.888,4.889-4.888C90.67,21.859,92.86,24.048,92.86,26.747z"/>
				</g>
			</g>
            <g style="opacity:0.3;">
				<g>
					<path style="fill:#FFFFFF;" d="M85.017,24.279c-0.257,0.486-0.468,1.191-0.203,1.74c0.193,0.399,0.458,0.24,0.711-0.022
						c0.579-0.603,1.16-1.162,1.871-1.62c0.259-0.167,1.812-0.847,1.416-1.33c-0.394-0.481-1.276-0.408-1.804-0.276
						C86.176,22.98,85.41,23.537,85.017,24.279z"/>
				</g>
			</g>
		</g>
                <g class="bead" id="{{beadsList[11].id}}" (click)="moveBeads($event)">
			<path style="fill:#E52427;" d="M92.941,26.747c0-2.698,2.19-4.888,4.889-4.888c2.699,0,4.889,2.19,4.889,4.888
				s-2.19,4.89-4.889,4.89C95.131,31.637,92.941,29.445,92.941,26.747"/>
                    <g style="opacity:0.3;">
				<g>
					<path style="fill:#FFFFFF;" d="M94.947,24.418c-0.257,0.486-0.468,1.191-0.203,1.74c0.193,0.399,0.458,0.24,0.711-0.022
						c0.579-0.603,1.16-1.162,1.871-1.62c0.259-0.167,1.812-0.847,1.416-1.33c-0.394-0.481-1.276-0.408-1.804-0.276
						C96.107,23.12,95.34,23.677,94.947,24.418z"/>
				</g>
			</g>
		</g>
                <g class="bead" id="{{beadsList[12].id}}" (click)="moveBeads($event)">
			<path style="fill:#E52427;" d="M102.801,26.747c0-2.698,2.19-4.888,4.889-4.888c2.699,0,4.889,2.19,4.889,4.888
				s-2.19,4.89-4.889,4.89C104.99,31.637,102.801,29.445,102.801,26.747"/>
                    <g style="opacity:0.3;">
				<g>
					<path style="fill:#FFFFFF;" d="M104.963,24.6c-0.257,0.486-0.468,1.191-0.203,1.74c0.193,0.399,0.458,0.24,0.711-0.022
						c0.579-0.603,1.16-1.162,1.871-1.62c0.259-0.167,1.812-0.847,1.416-1.33c-0.394-0.481-1.276-0.408-1.804-0.276
						C106.123,23.301,105.356,23.858,104.963,24.6z"/>
				</g>
			</g>
		</g>
                <g class="bead" id="{{beadsList[13].id}}" (click)="moveBeads($event)">
			<path style="fill:#E52427;" d="M112.66,26.747c0-2.698,2.19-4.888,4.889-4.888c2.699,0,4.889,2.19,4.889,4.888
				s-2.19,4.89-4.889,4.89C114.85,31.637,112.66,29.445,112.66,26.747"/>
                    <g style="opacity:0.3;">
				<g>
					<path style="fill:#FFFFFF;" d="M114.731,24.6c-0.257,0.486-0.468,1.191-0.203,1.74c0.193,0.399,0.458,0.24,0.711-0.022
						c0.579-0.603,1.16-1.162,1.871-1.62c0.259-0.167,1.812-0.847,1.416-1.33c-0.394-0.481-1.276-0.408-1.804-0.276
						C115.89,23.301,115.124,23.858,114.731,24.6z"/>
				</g>
			</g>
		</g>
                <g class="bead" id="{{beadsList[14].id}}" (click)="moveBeads($event)">
			<path style="fill:#E52427;" d="M122.519,26.747c0-2.698,2.19-4.888,4.889-4.888c2.699,0,4.889,2.19,4.889,4.888
				s-2.19,4.89-4.889,4.89C124.709,31.637,122.519,29.445,122.519,26.747"/>
                    <g style="opacity:0.3;">
				<g>
					<path style="fill:#FFFFFF;" d="M124.498,24.6c-0.257,0.486-0.468,1.191-0.203,1.74c0.193,0.399,0.458,0.24,0.711-0.022
						c0.579-0.603,1.16-1.162,1.871-1.62c0.259-0.167,1.812-0.847,1.416-1.33c-0.394-0.481-1.276-0.408-1.804-0.276
						C125.658,23.301,124.891,23.858,124.498,24.6z"/>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g class="bead" id="{{beadsList[15].id}}" (click)="moveBeads($event)">
			<g>
				<path style="fill:#DADADA;" d="M142.209,26.747c0,2.698-2.19,4.89-4.889,4.89c-2.699,0-4.889-2.192-4.889-4.89
					s2.19-4.888,4.889-4.888C140.019,21.859,142.209,24.048,142.209,26.747z"/>
			</g>
            <g style="opacity:0.6;">
				<g>
					<path style="fill:#FFFFFF;" d="M134.366,24.279c-0.257,0.486-0.468,1.191-0.203,1.74c0.193,0.399,0.458,0.24,0.711-0.022
						c0.579-0.603,1.16-1.162,1.871-1.62c0.259-0.167,1.812-0.847,1.416-1.33c-0.394-0.481-1.276-0.408-1.804-0.276
						C135.525,22.98,134.759,23.537,134.366,24.279z"/>
				</g>
			</g>
		</g>
                <g class="bead" id="{{beadsList[16].id}}" (click)="moveBeads($event)">
			<path style="fill:#DADADA;" d="M142.29,26.747c0-2.698,2.19-4.888,4.889-4.888c2.699,0,4.889,2.19,4.889,4.888
				s-2.19,4.89-4.889,4.89C144.48,31.637,142.29,29.445,142.29,26.747"/>
                    <g style="opacity:0.6;">
				<g>
					<path style="fill:#FFFFFF;" d="M144.296,24.418c-0.257,0.486-0.468,1.191-0.203,1.74c0.193,0.399,0.458,0.24,0.711-0.022
						c0.579-0.603,1.16-1.162,1.871-1.62c0.259-0.167,1.812-0.847,1.416-1.33c-0.394-0.481-1.276-0.408-1.804-0.276
						C145.456,23.12,144.689,23.677,144.296,24.418z"/>
				</g>
			</g>
		</g>
                <g class="bead" id="{{beadsList[17].id}}" (click)="moveBeads($event)">
			<path style="fill:#DADADA;" d="M152.15,26.747c0-2.698,2.19-4.888,4.889-4.888c2.699,0,4.889,2.19,4.889,4.888
				s-2.19,4.89-4.889,4.89C154.339,31.637,152.15,29.445,152.15,26.747"/>
                    <g style="opacity:0.6;">
				<g>
					<path style="fill:#FFFFFF;" d="M154.312,24.6c-0.257,0.486-0.468,1.191-0.203,1.74c0.193,0.399,0.458,0.24,0.711-0.022
						c0.579-0.603,1.16-1.162,1.871-1.62c0.259-0.167,1.812-0.847,1.416-1.33c-0.394-0.481-1.276-0.408-1.804-0.276
						C155.472,23.301,154.705,23.858,154.312,24.6z"/>
				</g>
			</g>
		</g>
                <g class="bead" id="{{beadsList[18].id}}" (click)="moveBeads($event)">
			<path style="fill:#DADADA;" d="M162.009,26.747c0-2.698,2.19-4.888,4.889-4.888c2.699,0,4.889,2.19,4.889,4.888
				s-2.19,4.89-4.889,4.89C164.198,31.637,162.009,29.445,162.009,26.747"/>
                    <g style="opacity:0.6;">
				<g>
					<path style="fill:#FFFFFF;" d="M164.08,24.6c-0.257,0.486-0.468,1.191-0.203,1.74c0.193,0.399,0.458,0.24,0.711-0.022
						c0.579-0.603,1.16-1.162,1.871-1.62c0.259-0.167,1.812-0.847,1.416-1.33c-0.394-0.481-1.276-0.408-1.804-0.276
						C165.239,23.301,164.473,23.858,164.08,24.6z"/>
				</g>
			</g>
		</g>
                <g class="bead" id="{{beadsList[19].id}}" (click)="moveBeads($event)">
			<path style="fill:#DADADA;" d="M171.868,26.747c0-2.698,2.19-4.888,4.889-4.888c2.699,0,4.889,2.19,4.889,4.888
				s-2.19,4.89-4.889,4.89C174.058,31.637,171.868,29.445,171.868,26.747"/>
                    <g style="opacity:0.6;">
				<g>
					<path style="fill:#FFFFFF;" d="M173.847,24.6c-0.257,0.486-0.468,1.191-0.203,1.74c0.193,0.399,0.458,0.24,0.711-0.022
						c0.579-0.603,1.16-1.162,1.871-1.62c0.259-0.167,1.812-0.847,1.416-1.33c-0.394-0.481-1.276-0.408-1.804-0.276
						C175.007,23.301,174.24,23.858,173.847,24.6z"/>
				</g>
			</g>
		</g>
	</g>
</g>
</svg>
</ng-template>

